module.exports = __webpack_public_path__ + "static/media/wt1.f69e140d.png";